import React, { useState } from 'react'

/**
 * Hook to expose handlers that rely on anchor elements (things like MUI Menu)
 */
export function useAnchorElement<TElement = HTMLElement>() {
  const [anchorElement, setAnchorElement] = useState<null | TElement>(null)
  const isOpen = Boolean(anchorElement)
  const handleAnchorElementClick = (event: React.MouseEvent<TElement>) => {
    setAnchorElement(event.currentTarget)
  }
  const handleAnchorElementClose = () => {
    setAnchorElement(null)
  }

  return {
    isOpen,
    anchorElement,
    setAnchorElement,
    handleAnchorElementClick,
    handleAnchorElementClose
  }
}
